module.exports = __webpack_public_path__ + "static/media/MyinvitationsEmptyImg.cf3cf0df.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/new-images/MyinvitationsEmptyImg.png
// module id = 1089
// module chunks = 0